import { render, staticRenderFns } from "./codeTest.vue?vue&type=template&id=1d12a938&scoped=true"
import script from "./codeTest.vue?vue&type=script&lang=js"
export * from "./codeTest.vue?vue&type=script&lang=js"
import style0 from "./codeTest.vue?vue&type=style&index=0&id=1d12a938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d12a938",
  null
  
)

export default component.exports